__turbopack_context__.v({
  "driftAcross": "onboardingIntroSkyClouds-module__j7ti0G__driftAcross",
  "driftAcrossSlow": "onboardingIntroSkyClouds-module__j7ti0G__driftAcrossSlow",
  "lavaSwell": "onboardingIntroSkyClouds-module__j7ti0G__lavaSwell",
  "lavaSwellFirst": "onboardingIntroSkyClouds-module__j7ti0G__lavaSwellFirst",
  "lavaSwellFourth": "onboardingIntroSkyClouds-module__j7ti0G__lavaSwellFourth",
  "lavaSwellSecond": "onboardingIntroSkyClouds-module__j7ti0G__lavaSwellSecond",
  "lavaSwellThird": "onboardingIntroSkyClouds-module__j7ti0G__lavaSwellThird",
  "skyCloudMorphFade": "onboardingIntroSkyClouds-module__j7ti0G__skyCloudMorphFade",
  "skyCloudMorphOverlay": "onboardingIntroSkyClouds-module__j7ti0G__skyCloudMorphOverlay",
  "skyCloudMorphOverlaySlow": "onboardingIntroSkyClouds-module__j7ti0G__skyCloudMorphOverlaySlow",
  "skyCloudNight": "onboardingIntroSkyClouds-module__j7ti0G__skyCloudNight",
  "skyMoonWash": "onboardingIntroSkyClouds-module__j7ti0G__skyMoonWash",
});
